import Index from "../_components/AccountSettings/Index";

const AccountSettings = () => {
  return <Index />;
};

export default AccountSettings;
